import NotFound from "../../components/common/not-found/NotFound";
import UserTemplate from "../../views/UserTemplate";

const NotFoundPage = () => {
  return (
    <UserTemplate>
      <NotFound />
    </UserTemplate>
  );
};

export default NotFoundPage;
